<template>
    <div v-if="name" class="h-100">
    <VIPHome v-if="name === 'VIP'"></VIPHome>
    <FANHome v-if="name === 'FAN'"></FANHome>
    </div>
</template>

<script>
import VIPHome from './VIP/VIPHome.vue';
import FANHome from './FAN/FANHome.vue';

export default {
    data() {
        return {
            name: ''
        };
    },
    components: {
        VIPHome,
        FANHome
    },
    created() {
        this.name = this.$store.state.userProfile.role;
        if (!this.name) {
            this.$router.push('Login');
        }
    }
};
</script>
